import { MainTheme } from '@uma/react-commons/dist/index';
import styled from 'styled-components';

export const Value = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  text-overflow: ellipsis;

  && {
    @media screen and (${MainTheme.mediaQueries.maxWidthMobile}) {
      width: 271px;
    }
  }
`;

export const ValueContent = styled.div`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
